<template>
  <input
    ref="input"
    type="text"
    class="form-control"
    :class="inputClass"
    :placeholder="placeholder"
    :disabled="disabled"
    :readonly="readonly"
    :name="name"
    :id="id"
    :required="required"
    :value="displayValue"
    autocomplete="off"
    @input="onInput($event)"
    @keydown="onKeyDown($event)"
    @blur="onBlur($event)"
    @focus="onFocus($event)"
  />
</template>

<script>
export default {
  name: "PriceInput",
  props: {
    value: {
      type: [String, Number],
      default: "",
    },
    placeholder: {
      type: String,
      default: "0.00",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: "",
    },
    id: {
      type: String,
      default: "",
    },
    inputClass: {
      type: [String, Object, Array],
      default: "",
    },
    decimals: {
      type: Number,
      default: 2,
    },
  },
  data() {
    return {
      isFocused: false,
      displayValue: this.formatInitial(this.value),
    };
  },
  watch: {
    value(newVal) {
      if (!this.isFocused) {
        this.displayValue = this.formatInitial(newVal);
      }
    },
  },
  methods: {
    cleanRaw(val) {
      if (val === null || val === undefined) return "";
      let str = String(val).replace(/^\$\s*/, "").replace(/,/g, ".").trim();
      // Remover cualquier carácter que no sea dígito o punto
      str = str.replace(/[^0-9.]/g, "");
      // Permitir únicamente el primer punto decimal
      const parts = str.split(".");
      if (parts.length > 2) {
        str = parts[0] + "." + parts.slice(1).join("");
      }
      // Limitar la cantidad de decimales según el prop decimals
      const dotIndex = str.indexOf(".");
      if (dotIndex !== -1 && this.decimals >= 0) {
        const intPart = str.substring(0, dotIndex);
        const decPart = str.substring(dotIndex + 1, dotIndex + 1 + this.decimals);
        str = intPart + "." + decPart;
      }
      return str;
    },

    formatInitial(val) {
      if (val === null || val === undefined || val === "") return "";
      const cleaned = this.cleanRaw(val);
      if (cleaned === "") return "";
      const num = Number(cleaned);
      if (isNaN(num)) return cleaned;
      return num.toFixed(this.decimals);
    },

    onKeyDown(event) {
      // Permitir teclas de navegación y control
      const allowedKeys = [
        "Backspace",
        "Delete",
        "Tab",
        "Escape",
        "Enter",
        "ArrowLeft",
        "ArrowRight",
        "ArrowUp",
        "ArrowDown",
        "Home",
        "End",
      ];
      if (
        allowedKeys.includes(event.key) ||
        event.ctrlKey ||
        event.metaKey
      ) {
        return;
      }

      // Permitir punto o coma decimal si aún no existe en el valor o si reemplaza selección
      if (event.key === "." || event.key === ",") {
        const target = event.target;
        if (target.value.includes(".") && target.selectionStart === target.selectionEnd) {
          event.preventDefault();
        }
        return;
      }

      // Bloquear cualquier tecla no numérica (especialmente el signo '$')
      if (!/^[0-9]$/.test(event.key)) {
        event.preventDefault();
      }
    },

    onInput(event) {
      const raw = event.target.value;
      const cleaned = this.cleanRaw(raw);
      this.displayValue = cleaned;
      if (event.target.value !== cleaned) {
        event.target.value = cleaned;
      }
      this.$emit("input", cleaned);
    },

    onFocus() {
      this.isFocused = true;
    },

    onBlur() {
      this.isFocused = false;
      if (this.displayValue !== "") {
        const num = Number(this.displayValue);
        if (!isNaN(num)) {
          const formatted = num.toFixed(this.decimals);
          this.displayValue = formatted;
          this.$emit("input", formatted);
          this.$emit("change", formatted);
          return;
        }
      }
      this.$emit("change", this.displayValue);
    },
  },
};
</script>
